<h2 mat-dialog-title class="text-lg font-bold mb-1">Galería de Imágenes</h2>
<mat-dialog-content class="modal-content">
  <div class="flex flex-col md:flex-row gap-6">

    <!-- Columna izquierda: Área de carga -->
    <div *ngIf="isTypeValid && canEdit" class="flex-1">

      <!-- Área de drag and drop -->
      <div class="drop-zone" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.dragging]="isDragging">
        <div class="drop-content">
          <mat-icon class="drop-icon">cloud_upload</mat-icon>
          <p>Arrastra tus imágenes aquí</p>
          <p class="text-sm text-gray-500">o</p>
          <input type="file" #fileInput accept="image/*" multiple (change)="onFileSelected($event)"
            style="display: none">
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            <mat-icon>add_photo_alternate</mat-icon>
            Seleccionar imágenes
          </button>
        </div>
      </div>

      <!-- Previsualización -->
      <div *ngIf="selectedFiles.length > 0" class="preview-container mt-4">
        <h3 class="text-md font-medium mb-2">Imágenes a subir ({{ selectedFiles.length }})</h3>
        <div class="preview-grid">
          <div *ngFor="let file of selectedFiles; let i = index" class="preview-item">
            <img [src]="getPreview(file)" class="preview-image">
            <button mat-icon-button class="remove-btn" (click)="removeSelected(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <button mat-raised-button color="accent" (click)="uploadImages()" [disabled]="isUploading" class="mt-2">
          <mat-icon>cloud_upload</mat-icon>
          Subir {{ selectedFiles.length }} imagen(es)
        </button>
      </div>
    </div>

    <!-- Columna derecha: Galería existente -->
    <div *ngIf="galleryImages.length > 0" class="flex-1">
      <ngx-gallery [options]="galleryOptions" [images]="galleryImages"
        style="width: 100%; height: 400px; display: block; margin-top: 0;">
      </ngx-gallery>
    </div>

  </div>
</mat-dialog-content>


<mat-dialog-actions class="modal-actions flex justify-between">
  <button mat-button (click)="closeModal()">Cerrar</button>
</mat-dialog-actions>